import { memo } from "react";

import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import { RenderResourceRowCellProps } from ".";
import IacManagementResourceCell from "../components/ResourceCell";

const IacManagementTableResourceRowCellSpace = memo((props: RenderResourceRowCellProps) => {
  return (
    <IacManagementResourceCell {...props}>
      <TableCellEmpty />
    </IacManagementResourceCell>
  );
});

IacManagementTableResourceRowCellSpace.displayName = "IacManagementTableResourceRowCellSpace";

export default IacManagementTableResourceRowCellSpace;
